import { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import styles from './Views.module.css';
import { Alert, Box, Snackbar } from "@mui/material";
import { Header } from "../../components/Header";
import views, { ViewProps } from "../../data/views.data";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { LeftSidebar } from "../../components/LeftSidebar";
import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { AccountInfo, InteractionStatus } from "@azure/msal-browser";
import { AuthPlaceholder } from "../../components/AuthPlaceholder";
import { AccessDenied } from "../../components/AccessDenied";
import { useAuth } from "../../auth/useAuth";
import { Home } from "../Home";
import { Domains } from "../../data/Domains";


export const Views: React.FC = ( ) => {

  const [ drawerOpen, setDrawerOpen ] = useState( false );
  const [ isAuthorized, setIsAuthorized ] = useState<boolean>( false );

  
  const { domain, readonlyDomains, notificationMessage, notificationType, setNotificationText } = useContext( VillageConsoleContext );

  const routes = views
    .filter( ( view: ViewProps ) => !readonlyDomains.includes( domain as Domains ) || view.canBeSeenInReadonlyMode )
    .map( (view: ViewProps) => <Route path={view.path} element={view.element} key={view.index}/> );
  
  routes.push( <Route path="*" element={ <Home/> } key={-1 } /> );

  const { accounts, inProgress } = useMsal( );
  const isAuthenticated: boolean = useIsAuthenticated( );
  const accountInfo = useAccount( accounts[0] );
  const { authorize } = useAuth( );


  useEffect( ( ) => {

    const doAuthorization = async () => setIsAuthorized( await authorize( ) ); 

    if ( isAuthenticated && inProgress === InteractionStatus.None ) {
      
      doAuthorization(  );

    }

  }, [isAuthenticated, inProgress] );


  const getUserName = ( accountInfo: AccountInfo | null ) => {

    if( accountInfo?.name ) {

      const result = accountInfo?.name?.split(/,\s/);
      return `${result[1]} ${result[0]}`;
  
    }
  
    return '';

  };


  return (

    <>

      { ( !isAuthenticated || inProgress !== InteractionStatus.None ) && <AuthPlaceholder /> }

      { ( isAuthenticated && inProgress === InteractionStatus.None && !isAuthorized ) && <AccessDenied /> }

      { ( isAuthenticated && inProgress === InteractionStatus.None && isAuthorized ) && 
      
        <div style={{ display: 'flex', height: '100vh' }}>
          
          <Header openDrawer={() => setDrawerOpen( true )} userName={getUserName( accountInfo )}/>
          <LeftSidebar drawerOpen={drawerOpen} closeDrawer={() => setDrawerOpen( false )}/>
          
          <Box component="main" className={styles.content} sx={{ ...(drawerOpen && { marginLeft: '300px;',  transition: 'margin-left 450ms cubic-bezier(0.23, 1, 0.32, 1)' }) }}>
            <Routes>
              {routes}
            </Routes>
          </Box>
          
          <Snackbar open={ notificationMessage !== '' } autoHideDuration={ 6000 } onClose={ ( ) => setNotificationText( '' ) }>
              <Alert onClose={ ( )  => setNotificationText( '' ) } severity={ notificationType } sx={{ width: '100%' }}>
                { notificationMessage }
              </Alert>
          </Snackbar>

        </div>      
      
      }

    </>

  );

};